// Vendor imports
const { useSelector } = require('react-redux')
// Client V2 common imports
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSeriesFeed() {
  let hasSeriesFeed = true
  const isWindowTooNarrow = useMatchMedia('(max-width: 799px)')
  const isWindowTooShort = useMatchMedia('(max-height: 599px)')
  if (isWindowTooNarrow || isWindowTooShort) {
    hasSeriesFeed = false
  }
  /**
   * Assume that mobile devices are not wide enough for the series feed
   * @see https://app.asana.com/0/226524042134185/1194990412344191/f
   */
  const isMobile = useSelector(state => state.env.browser.has('mobile'))
  if (isMobile) {
    hasSeriesFeed = false
  }
  return hasSeriesFeed
}

module.exports = {
  useHasSeriesFeed
}
